import { getLink } from "../../../utils/utils";

import author from "./author";

const content = {
	esp: (
		`
        <div style="text-align: justify;">
            <p class="mb-2">
                Tatjana Auderskaja loĝas en Odeso. 
                Ŝi estas biologo kaj ekologo, kaj sufiĉe konata en Esperanto-medio: ekde 1991 ŝi instruas Esperanton kaj gvidas odesan junularan Esperanto-klubon “Verdaĵo”, 
                organizis kelkajn Lingvajn Festivalojn, eĉ estis membro de la Akademio de Esperanto en 2019-2025.
            </p>
            
            <p class="mb-2">
                En 2010 aperis ŝia sciencpopulara libro: “La mondo en guto da akvo: ilustrita rakonto pri malgrandaj estaĵoj”, 
                ricevinta en 2016 la premion Pirlot por la plej bona scienca libro de 2010-2016. 
                Plie, ŝia pasio estas diversaj intelektaj ludoj – la tradicio de tiaj ludoj dum multaj jaroj floras en ruslingva medio, 
                sed apenaŭ konatas alilande, do en 2016 Tatjana eldonigis la libron “Intelektaj amuzoj. Lingvaj ludoj en Esperanto”, 
                penante konatigi la verdan popolon kun tiu inda okupo.
            </p>
            
            <p class="mb-2">
                Nun ni povas konatiĝi kun ŝia beletra talento. 
                Prestiĝa eldonejo Dokumenta Esperanto-centro en Đurđevac produktis en 2024 – teknike altnivele kaj belaspekte – ŝian libron “Nokta vojaĝo”. 
                Sur 160 paĝoj troviĝas 60 verkoj, la aŭtorino konfesas: “mi ne estas ŝatanto de grandaj formoj”. 
                La enhavo estas varia, la libro konsistas el kvin partoj.
            </p>
            
            <p class="mb-2">
                “Prozaĵoj-Fantasto”: 16 rakontoj de sufiĉe tradicia stilo: aliplanedanoj, pereanta savenda naturo (tre senteblas la ekologia mondkoncepto de la aŭtorino), 
                danĝeraj eksperimentoj de tro facilanimaj esploristoj, diktatura socio plene reglamentanta ĉiujn vivdetalojn de ordinaruloj (rememoriĝas deprimigaj noveloj de Higinio García). 
                Tro pesimisme, tro malrealisme – sed ŝajne nun ĝuste tiaj fikciaĵoj estas modaj...
            </p>
            
            <p class="mb-2">
                “Prozaĵoj-Rakontoj”: 12 rakontoj – el kiuj kelkaj povus aparteni ankaŭ al la unua, fantasta parto. 
                Plejparte temas pri amo, en strangaj ekstremaj kondiĉoj. 
                En kelkaj rakontoj, laŭ nuna tradicio de mikronoveloj, lasta frazo ŝanĝas la tuton. 
                Jen filozofiaj rezonoj: ĉu maljuneco estas malbeno aŭ graco? Kelkaj rakontoj estas vere animskuaj. 
                Pleje pensigaj estas la finvortoj de la titoldona novelo: “Ne gravas ja kien! Gravas, ke mi iras kun la plejmulto, 
                kaj jam ne devas en suferoj serĉi MIAN PROPRAN vojon! Jen la vojo por ĈIUJ, kaj LA ĈIUJ ne povas erari!”
            </p>
            
            <p class="mb-2">
                Sekvas 15 “Mikronoveloj” – kvankam, mi jam diris, apenaŭ eblas meti limon inter diversaj prozaj ĝenroj en tiu ĉi libro. 
                Pluraj pecoj traktas analogiojn, paralelecon inter socio kaj organismo, inter viva korpo kaj tuta Tero (la ideo ne novas, tamen...). 
                Ie rolas antikvaj dioj, kaj jen estas kiplingeska fabelo “Kial jaguaro havas felon kun makuloj”... 
                Tre senteblas individua stilo kaj “ekologia mondkoncepto” de la aŭtorino.
            </p>
            
            <p class="mb-2">
                Du teatraĵoj – tute kutimstilaj. Se ne estus mencioj de kelkaj nuntempaj realaĵoj – eblus kredi, 
                ke “Ama kvadrato” estas verkita antaŭ pli ol cent jaroj, sed ĝi eĉ ne eltenas komparon kun tiamaj priesperantaj teatraĵoj de Karl Minor aŭ Nikolai Hohlov. 
                Ankaŭ la “Rok-opero pri Odeso” ne tre impresas...
            </p>
            
            <p class="mb-2">
                Pli bonas la poezia parto. Tamen la serio de parodioj “Griza kapreto” ĝueblas nur por ruslingvanoj, konantaj la parodiitajn poetojn. 
                La stilo de ĉiu poeto rekoneblas eĉ en traduko, tamen kiu ne legis ilin originale – apenaŭ kaptos la tutan spriton. 
                “La bela markizino” estas fama francdevena kanto de 1930aj jaroj, bone konata ankaŭ en la rusa versio, kaj en Esperanto ĝin siatempe brile plenumis Veselin Damjanov. 
                Nun Auderskaja sprite travestias ĝin, mokante eternajn problemojn de multaj E-kluboj. 
                Sekvas serio da limerikoj, “Soneto pri kato”, amaraj rezonoj pri (mal)progreso de la homaro, kaj pluraj lirikaj poeziaĵoj. 
                Kelkaj poemoj estas distingitaj en la konkursoj “Poezio el ĉiuj ĉieloj” en Italio (2016-2021).
            </p>
            
            <p class="mb-2">
                Ekologia mondkoncepto, maltrankvilo pri nuna stato de la naturo kaj de la homaro, traas la tutan libron. 
                Indas fari paŭzon post tralego de ĉiu ero, por mediti...
            </p>
        </div>
		`
	)
}

const itemName = {
	esp: 'Kunvojaĝu'
}

const itemBookInfo = {
	esp: {
		content: `
			<p>Valentin Melnikov</p>
		`
	}
}

const item = {
	itemlink: getLink(itemName.esp),
	esp: {
		itemName: itemName.esp,
		itemContent: content.esp,
		itemAuthor: author.esp,
        itemBookInfo: itemBookInfo.esp
	}
}

export default item;

